import moment from 'moment';

const isValidDate = date => moment(date).isValid();

export default isValidDate;
